module.exports = __webpack_public_path__ + "static/media/1.d6d83903.svg";